
const state = {
  dataUri: "",
  doc: "",
  displayPDF: false,
  fileName: "test.pdf"
};

const getters = {
  pdfDataUri(state) {
    return state.dataUri;
  },
  pdfDoc(state) {
    return state.doc;
  },
  displayPDF(state) {
    return state.displayPDF;
  },
  pdfFileName(state) {
    return state.fileName;
  }
};

const mutations = {
  updateDataUri(state, dataUri) {
    state.dataUri = dataUri;
  },
  updateDoc(state, doc) {
    state.doc = doc;
  },
  showPDF(state, status) {
    state.displayPDF = status;
  },
  setPdfFileName(state, fileName) {
    state.fileName = fileName;
  }

};

export default {
  state,
  getters,
  mutations
};